import React from "react"
import ImageCols from "./project-page/imageCols"
import Thumbnail from "../components/thumbnail"


const WorkSamples = () => {
    const Project = {
        gasp: {
          image:'https://images-mmoore.s3.amazonaws.com/thumbnails/gasp.png',
          detail: 'Web App',
          alt:'GASP Gallery : Web App Study',
        },
        foodie: {
          image:'https://images-mmoore.s3.amazonaws.com/thumbnails/foodie.png',
          detail: 'mobile App',
          alt:'Foodie: Mobile App Study',
    
        },
        mailchimp: {
          image:'https://images-mmoore.s3.amazonaws.com/thumbnails/mc.png',
          detail: 'Web App',
          alt:'Mailchimp : Web App Study',
        }
      }
    
    return (
    <div className="contained center">
        <h3>Recent Work Samples</h3>
        <br/>
        <ImageCols>
            <Thumbnail to="gasp" src={Project.gasp.image} alt={Project.gasp.alt} detail={Project.gasp.detail}/>
            <Thumbnail to="foodie" src={Project.foodie.image} alt={Project.foodie.alt} detail={Project.foodie.detail}/>
            <Thumbnail to="mailchimp" src={Project.mailchimp.image} alt={Project.mailchimp.alt} detail={Project.mailchimp.detail}/>
            </ImageCols>
        </div>
    );
} 

export default WorkSamples